import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { all_routes } from "@/feature-module/router/all-routes";
import ImageWithBasePath from "@/core/data/img/ImageWithBasePath";
import useAuth from "../hooks/use-auth";
import { UserType } from "../../auth/data/model/auth-model";

const Header = () => {
  const { user, isAuthenticated } = useAuth();
  const routes = all_routes;
  const location = useLocation();
  const onHandleMobileMenu = () => {
    const root = document.getElementsByTagName("html")[0];
    root.classList.add("menu-opened");
  };
  const onHandleCloseMenu = () => {
    const root = document.getElementsByTagName("html")[0];
    root.classList.remove("menu-opened");
  };
  // Define interface for header items to explicitly type roles
  interface HeaderItem {
    tittle: string;
    showAsTab: boolean;
    separateRoute: boolean;
    routes?: string;
    hasSubRoute?: boolean;
    showSubRoute?: boolean;
    roles?: UserType[];
    menu?: {
      menuValue: string;
      routes?: string;
      hasSubRoute: boolean;
      showSubRoute: boolean;
      showAsTab2?: boolean;
      subMenus?: {
        menuValue: string;
        routes?: string;
        hasSubRoute: boolean;
        showSubRoute: boolean;
        subMenus: any[];
      }[];
    }[];
  }

  const header: HeaderItem[] = [
    {
      tittle: "Home",
      showAsTab: false,
      separateRoute: true,
      routes: routes.home,
      hasSubRoute: false,
      showSubRoute: false,
    },
    {
      tittle: "About Us",
      showAsTab: false,
      separateRoute: true,
      routes: routes.aboutUs,
      hasSubRoute: false,
      showSubRoute: false,
    },
    {
      tittle: "Services",
      showAsTab: false,
      separateRoute: true,
      routes: routes.allServices,
      hasSubRoute: false,
      showSubRoute: false,
    },
    {
      tittle: "Gallery",
      showAsTab: false,
      separateRoute: true,
      routes: routes.gallery,
      hasSubRoute: false,
      showSubRoute: false,
    },
    {
      tittle: "Testimonials",
      showAsTab: false,
      separateRoute: true,
      routes: routes.testimonials,
      hasSubRoute: false,
      showSubRoute: false,
    },
    {
      tittle: "Contact Us",
      showAsTab: false,
      separateRoute: true,
      routes: routes.contactUs,
      hasSubRoute: false,
      showSubRoute: false,
    },
  ]; // Use type assertion to avoid type errors
  // Filter navMain items based on user role
  const filteredNavMain = header.filter(
    (item) =>
      !item.roles || (user && item.roles.includes(user.type as UserType))
  );
  const [headerState, setHeaderState] =
    useState<typeof header>(filteredNavMain);
  const customStyle = {
    background: "rgb(23, 124, 130)",
    // location.pathname === routes.home ? "rgb(23, 124, 130)" : "#ffffff",
  };
  const expandSubMenus = (menu: string) => {
    sessionStorage.setItem("menuValue", menu);

    // Update `header` by toggling `showAsTab` for the clicked menu
    const updatedHeader = headerState.map((mainMenu) => {
      if (mainMenu.tittle === menu) {
        // Toggle `showAsTab` for the selected `mainMenu`
        return { ...mainMenu, showAsTab: !mainMenu.showAsTab };
      } else {
        // Collapse all other menus
        return { ...mainMenu, showAsTab: false };
      }
    });

    // Use type assertion to force TypeScript to accept the update
    setHeaderState(updatedHeader as typeof header);
  };

  const expandSubMenus2 = (menu: string) => {
    sessionStorage.setItem("menuValue2", menu);

    const updatedHeader = headerState.map((mainMenu) => {
      if (mainMenu.menu) {
        // Update nested menus if they exist
        const updatedMenu = mainMenu.menu.map((resMenu) => {
          if (resMenu.menuValue === menu) {
            // Toggle the `showAsTab` for the selected menu
            return {
              ...resMenu,
              showAsTab2: false,
            };
          } else {
            // Collapse all other menus
            return {
              ...resMenu,
              showAsTab2: false,
            };
          }
        });

        return {
          ...mainMenu,
          menu: updatedMenu,
        };
      }

      return mainMenu;
    });

    // Use type assertion to force TypeScript to accept the update
    setHeaderState(updatedHeader as typeof header);
  };

  return (
    <header
      className={
        // location.pathname === routes.home
        //   ? "header header-trans"
        //   : "header header-sticky"
        "header header-trans"
      }
      style={customStyle}
    >
      <div className="container-fluid">
        <nav className="navbar navbar-expand-lg header-nav">
          <div className="navbar-header">
            <Link id="mobile_btn" to="#" onClick={() => onHandleMobileMenu()}>
              <span className="bar-icon">
                <span />
                <span />
                <span />
              </span>
            </Link>
            <Link to={routes.home} className="navbar-brand logo">
              {/* <ImageWithBasePath src="assets/img/logo.svg" className="img-fluid" alt="Logo" /> */}{" "}
              {location.pathname === routes.home ? (
                <ImageWithBasePath
                  src="assets/img/logo.webp"
                  className="img-fluid"
                  alt="Logo"
                  width={100}
                  height={42}
                />
              ) : (
                <ImageWithBasePath
                  src="assets/img/logo.webp"
                  className="img-fluid"
                  alt="Another Image"
                  width={100}
                  height={42}
                />
              )}
            </Link>
          </div>
          <div className="main-menu-wrapper">
            <div className="menu-header">
              <Link to={routes.home} className="menu-logo">
                <ImageWithBasePath
                  src="assets/img/logo.webp"
                  className="img-fluid"
                  alt="Logo"
                  width={100}
                  height={42}
                />
              </Link>
              <Link
                id="menu_close"
                onClick={() => onHandleCloseMenu()}
                className="menu-close"
                to="#"
              >
                {" "}
                <i className="fas fa-times" />
              </Link>
            </div>
            <ul className="main-nav">
              {" "}
              {headerState.map((mainMenus, mainIndex) => (
                <React.Fragment key={mainIndex}>
                  {mainMenus.separateRoute ? (
                    <li
                      key={mainIndex}
                      className={
                        location.pathname === (mainMenus.routes || "")
                          ? "active"
                          : ""
                      }
                    >
                      <Link to={mainMenus.routes || "#"}>
                        {mainMenus.tittle}
                      </Link>
                    </li>
                  ) : (
                    <li
                      className={`has-submenu ${mainMenus?.menu?.some((item) => location.pathname === (item?.routes || "")) ? "active" : ""}`}
                    >
                      <a onClick={() => expandSubMenus(mainMenus.tittle)}>
                        {mainMenus.tittle}{" "}
                        <i className="fas fa-chevron-down"></i>
                      </a>
                      <ul
                        className={`submenu ${mainMenus.showAsTab} ${mainMenus.showAsTab ? "d-block" : ""}`}
                      >
                        {mainMenus.menu?.map((menu, menuIndex) => (
                          <React.Fragment key={`${mainIndex}-${menuIndex}`}>
                            {menu.hasSubRoute ? (
                              <li
                                key={`${mainIndex}-${menuIndex}`}
                                className={`${menu.hasSubRoute ? "has-submenu" : ""} ${menu?.subMenus?.some((item) => location.pathname === (item?.routes || "")) ? "active" : ""}`}
                              >
                                <a
                                  className="hideonmob"
                                  onClick={() => {
                                    expandSubMenus2(menu.menuValue);
                                  }}
                                >
                                  {menu.menuValue}
                                </a>
                                <ul className={`submenu showonmob`}>
                                  {menu.subMenus?.map(
                                    (subMenu, subMenuIndex) => (
                                      <li
                                        key={`${mainIndex}-${menuIndex}-${subMenuIndex}`}
                                        className={
                                          location.pathname ===
                                          (subMenu.routes || "")
                                            ? "active"
                                            : ""
                                        }
                                      >
                                        <Link to={subMenu.routes || "#"}>
                                          {subMenu.menuValue}
                                        </Link>
                                      </li>
                                    )
                                  )}
                                </ul>
                              </li>
                            ) : (
                              <li
                                key={`${mainIndex}-${menuIndex}`}
                                className={
                                  location.pathname === (menu.routes || "")
                                    ? "active"
                                    : ""
                                }
                              >
                                <Link to={menu.routes || "#"}>
                                  {menu.menuValue}
                                </Link>
                              </li>
                            )}
                          </React.Fragment>
                        ))}
                      </ul>
                    </li>
                  )}
                </React.Fragment>
              ))}
            </ul>
          </div>
          <ul className="nav header-navbar-rht">
            <li className="nav-item">
              {isAuthenticated ? (
                <Link
                  to={all_routes.dashboard}
                  className="nav-link btn btn-white log-register"
                >
                  <span>
                    <i className="feather-pie-chart" />
                  </span>
                  Dashboard
                </Link>
              ) : (
                <>
                  <Link
                    to={routes.login}
                    className="nav-link btn btn-white log-register"
                  >
                    <span>
                      <i className="feather-users" />
                    </span>
                    Login
                  </Link>
                  {/* / <Link to={routes.register}>Register</Link> */}
                </>
              )}
            </li>
            {/* <li className="nav-item">
              <Link className="nav-link btn btn-secondary" to={routes.addCourt}>
                <span>
                  <i className="feather-check-circle" />
                </span>
                List Your Court
              </Link>
            </li> */}
          </ul>
        </nav>
      </div>
    </header>
  );
};

export default Header;
